<template>
  <span
    class="outcome-value"
    v-if="outcomeValue">
    {{ outcomeValue }}
    <outcome-indicator
      :direction="outcomeChange"
      v-if="isIndicatorActive"
    />
  </span>
  <span
    class="bet-special flex-center"
    v-else-if="outcome.valueSpecial">
    {{ outcome.valueSpecial }}
  </span>
  <span v-else>
    -
  </span>
</template>

<script>
import round from '@/filters/round';
import OutcomeIndicator from '@/components/common/outcome-indicator/OutocmeIndicator.vue';

export default {
  name: 'MatchBetOutcome',
  props: {
    outcome: {
      type: Object,
      default: () => {},
    },
  },
  components: { OutcomeIndicator },
  data() {
    return {
      isIndicatorActive: this.$store.state.settings.outcomeIndicator,
      outcomeChange: '',
      timeout: null,
    };
  },
  computed: {
    outcomeValue() {
      return this.outcome.value ? round(this.outcome.value) : null;
    },
  },
  watch: {
    outcomeValue(newVal, oldVal) {
      if (newVal > oldVal) this.outcomeChange = 'up';
      else if (newVal < oldVal) this.outcomeChange = 'down';
      else this.outcomeChange = 'no';

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.outcomeChange = 'no';
      }, 6000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.bet-special {
  color: $color-important-special;
  font-weight: $font-weight-bold;
  font-size: 0.875rem !important;
}

.outcome-value {
  z-index: 1;
  font-weight: 500;
  letter-spacing: -2px;
}
</style>
